<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->

<template>
	<div class="grey-page billing-panel">
		<section class="container">
			<h3 class="page__main-title">Billing</h3>

			<!-- FIRST COLUMN: Balance and Subscriptions -->
			<div class="mdc-layout-grid billing-panel-wrap">
				<div class="mdc-layout-grid__inner">
					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5 mdc-layout-grid__cell--span-12-tablet">
						<div class="mdc-layout-grid first-column container-shadow white-background">
							<div class="billing-panel__balance-icon--mobile">
								<i class="ico ico-price_tag"></i>
							</div>

							<!-- Current Balance Info -->
							<h3 class="billing-panel__balance-title">Current Balance</h3>
							<div class="mdc-layout-grid__inner">
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5 mdc-layout-grid__cell--span-8-tablet billing-panel__balance-icon">
									<i class="ico ico-price_tag"></i>
								</div>
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-8-tablet billing-panel__balance">
									£ {{ priceWithComma(balance,2) }}
								</div>
								<div v-if="tests_startDate" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet billing-panel__next-billing">
									Fastforward Now
								</div>
								<div v-if="tests_startDate" class="mdc-layut-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet billing-panel__next-billing-date">
									<span>{{ dateToYMD(Datex(tests_startDate)) }}</span>
								</div>
								<div v-if="tests_startDate" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet billing-panel__next-billing">
									Fastforward Date
								</div>
								<div v-if="tests_startDate" class="mdc-layut-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet billing-panel__next-billing-date">
									<span>{{ dateToYMD(new Date(tests_startDate)) }}</span>
								</div>
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet billing-panel__next-billing">
									Next Billing
								</div>
								<div class="mdc-layut-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet billing-panel__next-billing-date">
									<span>{{ billDate }}</span>
								</div>
							</div>

							<hr class="billing-panel__divider">

							<!-- Subscriptions Info -->
							<h3><a href="#" @click.prevent="$router.push('/marketplace')">Your subscriptions</a></h3>

							<div v-for="sub in subscriptions">
								<div class="mdc-layout-grid__inner billing-panel__subscriptions">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet font-smaller billing-panel__subscription tinyfix2">
										{{ sub.title.toUpperCase() }}<i class="ico ico-info" v-if="sub.description" v-tooltip.right="sub.description"></i>
									</div>
									<div class="mdc-layut-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-8-tablet font-smaller billing-panel__subscription-price tinyfix2">
										<span>£ {{ sub.price }}/{{ frequencyStr(sub.frequency.toLowerCase()) }}</span>
									</div>
								</div>
							</div>

							<hr class="billing-panel__divider">

							<!-- Payment Method -->
							<div class="billing-panel__payment-method__header">
								<h3>Payment Method</h3>
								<a class="billing-panel__payment-method__edit" v-if="iamAdmin()">{{ adminCards.length }} cards</a>
								<a class="billing-panel__payment-method__edit" v-else @click.prevent="paymentMethodDialog = true">{{ hasCard === true ? 'Edit' : 'New' }}</a>
							</div>


							<!-- Cards Info -->
							<!--
							<div v-for="card in cards">
							  <span>
							    {{ card.brand }} | {{ card.last4 }} |
							    <a href="javascript:;" v-if="default_card != card.id" @click.prevent="defaultCard(card.id)">Make default</a>
							    <span v-if="card.cvc_check !== 'pass'">
							      Invalid
							    </span>
							  </span>
							</div>
							-->

							<div v-if="iamAdmin()">
								<div class="mdc-layout-grid__inner billing-panel__payment-method" v-for="card in adminCards">
									<div class="mdc-layut-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-4-tablet billing-panel__payment-method__date">{{ card.email }}</div>
									<div class="mdc-layut-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-4-tablet billing-panel__payment-method__date">
										<span>Exp. Date  {{ card.card.exp_month }}/{{ card.card.exp_year }}</span>
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-4-tablet font-smaller billing-panel__payment-method__number">
										<i class="pf pf-visa" v-if="card.card.brand.toLowerCase() == 'visa'"></i>
										<i class="pf pf-mastercard" v-if="card.card.brand.toLowerCase() == 'mastercard'"></i>
										<i class="pf pf-american-express" v-if="card.card.brand.toLowerCase() == 'american express'"></i>
										<i class="pf pf-diners" v-if="card.card.brand.toLowerCase() == 'diners club'"></i>
										<i class="pf pf-discover" v-if="card.card.brand.toLowerCase() == 'discover'"></i>
										<i class="pf pf-jcb" v-if="card.card.brand.toLowerCase() == 'jcb'"></i>
										<i class="pf pf-unionpay" v-if="card.card.brand.toLowerCase() == 'union-pay'"></i>
										<i class="pf pf-credit-card" v-if="card.card.brand.toLowerCase() == 'unknown' || card.card.brand == ''"></i>
										 **** {{ card.card.last4 }}
									</div>
									<div class="mdc-layut-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-4-tablet font-smaller billing-panel__payment-method__status">
										<i class="ico ico-attention" v-if="card.card.cvc_check !== 'pass'"></i>
										<i class="ico ico-checkmark" v-else></i>
										<a href="javascript:;" @click.prevent="trashCard"><i class="ico ico-trash" style="color:red"></i></a>
									</div>
								</div>
							</div>
							<div class="mdc-layout-grid__inner billing-panel__payment-method" v-else>
								<div v-if="cards.length > 0" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-4-tablet font-smaller billing-panel__payment-method__type">
									Credit Card
								</div>
								<div v-if="cards.length <= 0" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-4-tablet font-smaller">
								<p>No information provided.</p>
								</div>

									<div v-if="cards.length > 0" class="mdc-layut-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-4-tablet billing-panel__payment-method__date">
										<span>Exp. Date  {{ cards[0].exp_month }}/{{ cards[0].exp_year }}</span>
									</div>
									<div v-if="cards.length > 0" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-4-tablet font-smaller billing-panel__payment-method__number">
										<i class="pf pf-visa" v-if="cards[0].brand.toLowerCase() == 'visa'"></i>
										<i class="pf pf-mastercard" v-if="cards[0].brand.toLowerCase() == 'mastercard'"></i>
										<i class="pf pf-american-express" v-if="cards[0].brand.toLowerCase() == 'american express'"></i>
										<i class="pf pf-diners" v-if="cards[0].brand.toLowerCase() == 'diners club'"></i>
										<i class="pf pf-discover" v-if="cards[0].brand.toLowerCase() == 'discover'"></i>
										<i class="pf pf-jcb" v-if="cards[0].brand.toLowerCase() == 'jcb'"></i>
										<i class="pf pf-unionpay" v-if="cards[0].brand.toLowerCase() == 'union-pay'"></i>
										<i class="pf pf-credit-card" v-if="cards[0].brand.toLowerCase() == 'unknown' || cards[0].brand == ''"></i>
										 **** {{ cards[0].last4 }}
									</div>
									<div v-if="cards.length > 0" class="mdc-layut-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-4-tablet font-smaller billing-panel__payment-method__status">
										<i class="ico ico-attention" v-if="cards[0].cvc_check !== 'pass'"></i>
										<i class="ico ico-checkmark" v-else></i>
										<a href="javascript:;" @click.prevent="trashCard"><i class="ico ico-trash" style="color:red"></i></a>
									</div>
							</div>

							<!-- Payment Method - Dialog -->
							<aside class="mdc-dialog billing-panel__payment-method__dialog text-left" :class="{'mdc-dialog--open': paymentMethodDialog}" role="alertdialog" aria-hidden="true" aria-labelledby="mdc-dialog-default-label" aria-describedby="mdc-dialog-default-description">
								<div class="mdc-button mdc-button--raised btn--spinner button btn-spin--visible" v-show="loadingCard === true"></div>
								<div class="mdc-dialog__surface mdc-dialog__body--scrollable" v-show="loadingCard === false">
									<header class="mdc-dialog__header mdc-layout-grid__inner billing-panel__payment-method__dialog-header">
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 text-right billing-panel__payment-method__dialog-close">
											<a @click.prevent="paymentMethodDialog = false;" class="mdc-dialog__footer__button--cancel"><i class="ico ico-delete"></i></a>
										</div>
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 text-center billing-panel__payment-method__dialog-title">
											<h3 class="">Payment Method</h3>
										</div>
									</header>
									<section class="mdc-dialog__body mdc-layout-grid__inner ">
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">

											<!-- Payment Options  -->
											<div class="mdc-layout-grid__inner billing-panel__payment-method__dialog-options">
												<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 billing-panel__payment-method__dialog-option" @click.prevent="isPayPal = false" :class="{'billing-panel__payment-method__dialog-option--selected': !isPayPal}">
													<i class="ico ico-bank_card"></i>
													<h3>Credit/Debit Card</h3>
												</div>
												<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 divider-title mq-sm-show" style="display: none;"><span>Or</span></div>
												<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 billing-panel__payment-method__dialog-option" style="display: none;" @click.prevent="isPayPal = true" :class="{'billing-panel__payment-method__dialog-option--selected': isPayPal}">
													<i class="pf pf-paypal-alt"></i>
													<h3>PayPal</h3>
												</div>
												<span class="triangle-up" :class="{'triangle-up--paypal': isPayPal}"></span>
											</div>

											<!-- Card Details Form -->
											<div class="billing-panel__payment-method__dialog-form">
												<form action="http://127.0.0.1/charge" method="post" id="payment-form" >
												  <div class="form-row">
													  <div class="text-updating-card" v-if="hasCard === true">
  														You are updating your card that already exists.
  														<!--
  															<button type="button" @click.prevent="manualCharge">Pay now</button> <button type="button" @click.prevent="updateCard">Update Card</button>
  														-->
  													  </div>
													  <div id="card-errors" role="alert">
  														 <span v-if="errorCard.error === true" class="is-danger" v-html="errorCard.msg"></span>
  														 <span v-else class="text-success" v-html="errorCard.msg"></span>
  														</div>
												    <!-- <label for="card-element" v-show="hasCard === false">
												      Credit/Debit Card
												    </label> -->
												    <div id="card-element">
												      <!-- A Stripe Element will be inserted here. -->
														<div class="field">

															<span class="brand"><i class="pf pf-credit-card" id="brand-icon"></i></span>
															<div id="card-element-card-number"></div>
															<label for="card-element-card-number">Card Number</label>
														</div>
														<div class="field half-width">
															<div id="card-element-card-expiry">
													    	</div>
															<label for="card-element-card-expiry">Expiration Date</label>
														</div>
														<div class="field half-width card-cvc">
															<div id="card-element-card-cvc">
													    	</div>
															<label for="card-element-card-cvc">CVC Code</label>
														</div>
												    </div>
												    <!-- Used to display form errors. -->
													 <!-- <button v-if="hasCard === false">Save card</button> -->
													</div>
													<!-- <div v-if="hasCard === true">
														<button type="button" @click.prevent="manualCharge">Pay now</button> <button type="button" @click.prevent="updateCard">Update Card</button>
													</div> -->
													<footer class="mdc-dialog__footer mdc-layout-grid__inner billing-panel__payment-method__dialog-footer">
		  												<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-9 billing-panel__payment-method__dialog-conditions text-right">
		  													<p>I have read and agreed with the <a href="#">Terms & Conditions.</a></p>
		  												</div>
		  												<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-3-tablet text-right">
		  													<button type="button" @click.prevent="updateCard" class="mdc-button mdc-button--raised billing-panel__payment-method__dialog-save-btn">Save</button>
		  												</div>
	  												</footer>
												</form>
											</div>

										</div>
									</section>

								</div>
							</aside>

						</div>
					</div>

					<!-- SECOND COLUMN: Usage Table -->
					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-12-tablet white-background container-shadow billing-panel__product-usage">
						<div class="mdc-layout-grid">
							<hr class="billing-panel__divider billing-panel__divider-second">
							<div class="mdc-layout-grid__inner">
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet billing-panel-table__title">
									<h3>Product Usage</h3>
								</div>
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet center-vertical-wrapper billing-panel-table__date">
									<div class="center-vertical billing-panel-table__navigation">
										<span>{{ billprev }} - {{ billnext }}</span>
										<a href="#" v-if="firstbill_at !== 0 && (monthLast.getTime() > firstbill_at)" @click.prevent="prevMonth" class="billing-panel-table__navigation-left"><i class="ico ico-arrow-left"></i></a>
										<a href="#" v-if="(billstart_month === 0 && monthview < 0) || (billstart_month === 1 && monthview < 1)" @click.prevent="nextMonth" class="billing-panel-table__navigation-right"><i class="ico ico-arrow-right"></i></a>
									</div>
								</div>
							</div>
						</div>
						<div class="mdc-layout-grid padding-top-0">
							<div class="mdc-layout-grid__inner">
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
									<div class="billing-panel-table">
									   <div class="billing-panel-table__heading">
									        <div class="billing-panel-table__cell">
									            <p>Product</p>
									        </div>
									        <div class="billing-panel-table__cell">
									            <p>Price</p>
									        </div>
									        <div class="billing-panel-table__cell">
									            <p>N.</p>
									        </div>
											  <div class="billing-panel-table__cell">
									            <p>Balance</p>
									        </div>
									    </div>
										 <div v-if="tracks" v-for="prod in tracks" class="billing-panel-table__row">
   									        <div class="billing-panel-table__cell billing-panel-table__name">
   									            <p>{{ prod.item.title ? prod.item.title : prod.item.itemId }} {{ iamAdmin() === true ? "("+(statusDate(prod.status,(prod.prorata_at ? prod.prorata_at : prod.created_at)).toUpperCase())+")" : "" }}</p> <!-- TODO: DYNAMIC! -->
   									        </div>
   									        <div class="billing-panel-table__cell">
   									            <p>£ {{ priceWithComma((prod.total && prod.prorata_at && isNow(prod.created_at)) ? parseFloat(prod.total) : parseFloat(prod.item.price),2) }}</p> <!-- TODO: DYNAMIC! -->
   									        </div>
   									        <div class="billing-panel-table__cell">
   									            <p>{{ prod.quantity == 1 ? "-" : prod.quantity }}</p>
   									        </div>
   											  <div class="billing-panel-table__cell">
   									            <p>£ {{ priceWithComma((prod.total && prod.prorata_at && isNow(prod.created_at) ? prod.total : parseFloat(prod.item.price)) * parseFloat(prod.quantity),2) }}</p>
   									        </div>
			 							</div>
										<!-- Total VAT -->
										<div class="billing-panel-table__row">
											<div class="billing-panel-table__cell">
												<p></p>
											</div>
											<div class="billing-panel-table__cell">
												<p></p>
											</div>
											<div class="billing-panel-table__cell billing-panel-table__total">
												<p>VAT <small>{{ vat * 100 }}%</small></p>
											</div>
											<div class="billing-panel-table__cell billing-panel-table__total">
												<p>£ {{ priceWithComma(products_vat,2) }}</p>
											</div>
										</div>
										<!-- Total Balance -->
										<div class="billing-panel-table__row">
											<div class="billing-panel-table__cell">
												<p></p>
											</div>
											<div class="billing-panel-table__cell">
												<p></p>
											</div>
											<div class="billing-panel-table__cell billing-panel-table__total">
												<p>Total</p>
											</div>
											<div class="billing-panel-table__cell billing-panel-table__total">
												<p>£ {{ priceWithComma(products_total,2) }}</p>
											</div>
										</div>
									</div>

									<hr class="billing-panel__divider mq-sm-show">

									<div class="billing-panel__invoices" v-if="invoices.length > 0">
										<div class="mdc-layout-grid__inner">
											<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-tablet tinyfix">
												<h3>Invoices</h3>
											</div>
										</div>
										<div class="billing-panel-table">
											<div class="billing-panel-table__heading">
												<div class="billing-panel-table__cell">
												  <p>Issued date</p>
												</div>
												<div class="billing-panel-table__cell">
												  <p>Status</p>
												</div>
												<div class="billing-panel-table__cell">
												  <p>Total</p>
												</div>
												<div class="billing-panel-table__cell">
												  <p></p>
											 	</div>
											</div>

										<div v-for="inv in invoices" class="billing-panel-table__row">
											 <div class="billing-panel-table__cell billing-panel-table__name">
												  <p>{{ inv.date }}</p>
											 </div>
											 <div class="billing-panel-table__cell">
												  <p v-if="!inv.status">-</p>
												  <p v-else>{{ statusDate(inv.status,inv.realdate) }}</p>
											 </div>
											 <div class="billing-panel-table__cell">
												  <p>£ {{ priceWithComma((parseFloat(inv.total) + (parseFloat(inv.total) * 0.2)),2) }}</p>
											 </div>
											 <div class="billing-panel-table__cell">
												 <a class="" :href="inv.url" target="_blank">
												  	View invoice
											 	 </a>
											 </div>
									  </div>
									  </div>
								  </div>
										<!-- <div class="billing-panel__invoice" v-for="inv in invoices">
											<span class="billing-panel__invoice-name">
												{{ inv.name }}
											</span>
											<span class="billing-panel__invoice-date subtle-text">({{ inv.date }})</span> {{ inv.total }}, {{ inv.status }}
											<a class="billing-panel__invoice-btn" :href="inv.url" target="_blank">
												View invoice
											</a>
										</div> -->

									<!-- </div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
let tests_startDate = undefined;
tests_startDate = parseInt("0");
// Function responsible for Future timing
function Datex(startDate) {
	// Return default date
	if (startDate === undefined || startDate === null || startDate === 0)
		return new Date();

	// Get the fake date
	if (typeof startDate == 'object')
	   startDate = startDate.getTime();
	else
	   startDate = new Date(startDate).getTime();

	const oneHourNormalMs = 1 * 60 * 60 * 1000;
	const oneHourFastMs = 24 * oneHourNormalMs;

	const oneMsFast = oneHourFastMs / oneHourNormalMs;

	const nowx = new Date().getTime();
	const diffx = Math.abs(nowx - startDate);
	//console.log("Diff: " + diffx);
	const returnx = new Date(startDate + (diffx * oneMsFast));
	//console.log("Now is "+returnx.toString());
  	return returnx;
}

let now = Datex(tests_startDate);
var cardNumber, cardExpiry, cardCvc, stripe, elements;
// see into the future
//now = new Date(now.getFullYear(), now.getMonth(), now.getDate()+2);
let lastday = new Date(now.getFullYear(), now.getMonth()+1, 0).getDate();
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function ownDate(date) {
	let redate;
	if (!date || date === undefined){
		redate = Datex(tests_startDate);
	} else if (!isNaN(date) && date.toString().length !== 13) {
		return parseInt(date);
	} else if (!isNaN(date) && date.toString().length === 13) {
		redate = new Date(parseInt(date));
	} else if (typeof date === 'string') {
		redate = new Date(date);
	} else {
		redate = Datex(tests_startDate);
	}
	const gott = parseInt(redate.getFullYear()+""+("0" + (redate.getMonth()+1)).slice(-2)+""+("0" + redate.getDate()).slice(-2));
	return gott;
}










/*
function customDate(datetime,realtime) {

	if (!realtime)
		realtime = new Date().getTime();

	const timeday = 3600000 * this.billspeed;
	const timeday =
	let fakeDate = new Date(realtime);


}
*/

//var billspeed = 1;
/*
var milli = Date.prototype.getTime;
Date.prototype.getTime = function(){
	if (billspeed !== 24)
	 return milli.call(this) - (milli.call(this) / (billspeed * 3600000));
	else
    return milli.call(this);
};
console.log(new Date().getTime());

Date.prototype.addHours = function(h) {
   this.setTime(this.getTime() + (h*60*60*1000));
   return this;
}
*/

Date.prototype.addHours = function(h) {
   this.setTime(this.getTime() + (h*60*60*1000));
   return this;
}

Date.prototype.addDays = function(h) {
   this.setTime(this.getTime() + (h*24*60*60*1000));
   return this;
}

Date.prototype.addMonths = function(m) {
   this.setTime(this.getTime() + (m*30*24*60*60*1000));
   return this;
}


export default {
	data: function() {
	 return {
		 vat: .20,
		 balance: 0,
		 errorCard: "",
		 hasCard: false,
		 loadingCard: false,
		 cards: [],
		 default_card: "",
		 billstart_month: 0,
		 cardInfo: [],
		 billDate: '-',
		 billtimestamp: Datex(tests_startDate).getTime(),
		 billDay: '-',
		 billprev: '',
		 billnext: '',
		 firstbill_at: 0,
		 tests_startDate: 0,
		 monthview: 0,
		 monthNow: new Date(Datex(tests_startDate).setMonth(now.getMonth()+1)),
		 monthLast: new Date(Datex(tests_startDate).setMonth(now.getMonth())),
		 thismonth: [],
		 tracks: {},
		 invoices: [],
		 history: {},
		 subscriptions: [],
		 subscriptions_tracks: [],
		 products: [],
		 products_vat: 0,
		 products_total: 0,
		 paymentMethodDialog: false,
		 adminCards: [],
		 isPayPal: false,
		 changedDate_working: 0
	 }
	},
	created: async function() {
	},
	watch: {
		paymentMethodDialog: async function() {
				this.showStripe();
		},
		monthview: async function(val) {
			await this.updateSeason();
			this.changedDate(true);
		},
		monthNow: async function(val) {
			this.changedDate();
		},
		monthLast: async function(val) {
			this.changedDate();
		},
		isPayPal: async function(isPayPal){
			if (isPayPal) {
				this.showPaypal();
			} else {
				this.showStripe();
			}

		}
	},
	async mounted() {
		let that = this;
	  setTimeout(async function() {
			stripe = Stripe(process.env.BA_STRIPEKEY);
		 	 elements = stripe.elements();
		 	 await that.loadPayments();
		 	 now = Datex(tests_startDate);
		 	 await that.loadBilling();
		 	 that.populateSubscriptions();
		 	 that.refreshBilling();
	  },2000);
   },
	computed: {
	},
	methods: {
		statusDate(status,date) {
			if (this.monthview == this.billstart_month){
				return status.toUpperCase() == 'RENEWED' ? 'paid' : status;
			} else {
				return status;
			}
		},
		priceWithComma(price,decimals) {
			var splitPrice = price;
			if (typeof price != 'string') {
				splitPrice = splitPrice.toString();
			}

			if (splitPrice.indexOf(',') !== -1) {
				let resplitPrice = splitPrice.match(/\d+\,\d+/)[0];
				let rere = resplitPrice;
				rere = rere.replace(',','.');
				splitPrice = splitPrice.replace(resplitPrice,rere)
			}

			if (decimals) {
				splitPrice = parseFloat(splitPrice).toFixed(decimals);
			}

      	return splitPrice;
		},
		dateToYMD(date) {
		    var strArray=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		    var h = date.getHours();
			 var mm = date.getMinutes();
		    //var am_pm = date.getHours() >= 12 ? "PM" : "AM";
		    var l = date.toLocaleString([], { hour12: true});
		    var d = date.getDate();
		    var m = strArray[date.getMonth()];
		    var y = date.getFullYear();
		    return (d <= 9 ? '0' + d : d) + ' ' + m + ' ' + y + ', ' + (h <= 9 ? '0' + h : h) + ':'+(mm <= 9 ? '0' + mm : mm);
		},
		Datex(startDate) {
			// Return default date
			if (startDate === undefined || startDate === null || startDate === 0)
				return new Date();

			// Get the fake date
			if (typeof startDate == 'object')
			   startDate = startDate.getTime();
			else
			   startDate = new Date(startDate).getTime();

			const oneHourNormalMs = 1 * 60 * 60 * 1000;
			const oneHourFastMs = 24 * oneHourNormalMs;

			const oneMsFast = oneHourFastMs / oneHourNormalMs;

			const nowx = new Date().getTime();
			const diffx = Math.abs(nowx - startDate);
			//console.log("Diff: " + diffx);
			const returnx = new Date(startDate + (diffx * oneMsFast));
			//console.log("Now is "+returnx.toString());
		  	return returnx;
		},
		isNow(datet,abs) {
			const nowdt = new Date(datet).getTime();
			let truefalse = (nowdt >= this.monthLast.getTime() && nowdt <= this.monthNow.getTime() );
			//console.log(truefalse+' Now '+(new Date(nowdt).toString())+' vs '+this.monthNow.toString());
			//console.log(truefalse+' Last '+(new Date(nowdt).toString())+' vs '+this.monthLast.toString());
			if (abs) {
				let dtre = this.Datex();
				var firstDay = new Date(dtre.getFullYear(), dtre.getMonth(), 1);
				var lastDay = new Date(dtre.getFullYear(), dtre.getMonth() + 1, 0);

				truefalse = (nowdt >= firstDay.getTime() && nowdt <= lastDay.getTime() );
			}
			return truefalse;
		},
		async arrExtend(obj, src) {
		    await Promise.all(Object.keys(src).map(key => { if (src[key] && obj[key] != 'cancelled' && obj[key] != 'expired') obj[key] = src[key]; }));
		    return obj;
		},
		async trackExistsUpdate(track) {
			if (this.iamAdmin() === false && (track.status == 'cancelled' || track.status == 'expired' || track.status == 'paid')) {
				if (this.tracks[track.trackId]) {
					delete this.tracks[track.trackId];
				}
				return true;
			}
			const foundThisMonth = this.thismonth.filter(it => {
					return it.trackId === track.trackId;
			});
			const foundInvoice = this.invoices.filter(it => {
					return it.trackId.indexOf(track.trackId) !== -1;
			});

			if (track.created_at && this.isNow(track.created_at) === true) {
				if (this.tracks[track.trackId]) {
					this.tracks[track.trackId] = await this.arrExtend(this.tracks[track.trackId],track);
					//console.log('Populaing '+ track.item.itemId + ' with '+ track.status + " "+ track.created_at);
				} else {

					if (foundThisMonth && foundThisMonth[0])
						track.status = foundThisMonth[0].status;
					//console.log('Populaing2 '+ track.item.itemId + ' with '+ track.status + " "+ track.created_at);
					this.tracks[track.trackId] = track;
				}
			} else { // Not from current month
				if (track.created_at < this.monthNow.getTime()) {
					if (this.tracks[track.trackId]) {
						/*
						if (track.prorata_at) {
							this.tracks[track.trackId] = await this.arrExtend(this.tracks[track.trackId],track);
						}
						*/
						this.tracks[track.trackId] = await this.arrExtend(this.tracks[track.trackId],track);
						if (track.status == 'cancelled' || track.status == 'expired' || track.status == 'paid') {
							delete this.tracks[track.trackId];
						}
					} else {
						if (foundInvoice[0]) {
							const isnow = this.isNow(foundInvoice[0].invoicedate);
							//console.log(track.item.itemId + ' ' + isnow);
							if (isnow === true)
								this.tracks[track.trackId] = track;
						} else {
							if (track.status == 'renewed') { // Normalize subscriptions
								//console.log(track.item.itemId + ' ' +track.status);
								//console.log(new Date(track.created_at).toString());
								track.status = 'issued';
								this.tracks[track.trackId] = track;
							}
						}

					}
				}
				/*
				if (track.created_at < this.monthLast.getTime()) {
					if (this.tracks[track.trackId]) {
						delete this.tracks[track.trackId];
					}
				}
				*/


			}

			if (this.tracks[track.trackId]) { // Find first item billed time
				if (this.firstbill_at === 0 || this.tracks[track.trackId].created_at < this.firstbill_at) {
					this.firstbill_at = this.tracks[track.trackId].created_at;
				}
			}
		},
		async storeTracks(tracks) {
			let rethis = this;
			await Promise.all(tracks.map(async track => {
				if (track.item_updated) {
					track.item_updated.trackId = track.trackId;
					await rethis.trackExistsUpdate(track.item_updated);
				} else
					await rethis.trackExistsUpdate(track);
			}));
		},
		async loadBilling() {
			try {
				const billData = await api({endpoint: this.config.services.billing, path: '/billingpage', method: 'GET'});
				if (!isNaN(billData.balance)) {
					this.balance = billData.balance;
					this.billDay = billData.billday;
					//console.log("lastday1 ",lastday);
					//console.log("lastday2 ",billData.billday);
					if (parseInt(lastday) === parseInt(billData.billday))
						this.billDay = 'endmonth';
					// Calendar funcs
					this.monthNow.setDate(billData.billday);
					this.monthNow.setHours(23);
					this.monthNow.setMinutes(59);
					this.monthLast.setDate(billData.billday);
					this.monthLast.setHours(0);
					this.monthLast.setMinutes(1);
					this.billDate = Datex(this.tests_startDate);
					this.billDate.setDate(billData.billday);
					if (this.billDay != 'endmonth' && (parseInt(this.billDay) !== parseInt(lastday)) && (parseInt(now.getDate()) >= parseInt(billData.billday) || parseInt(now.getMonth()) != parseInt(this.billDate.getMonth()))) {
						this.monthview++;
						this.billstart_month = 1;
						this.billDate.addMonths(1);
					} else {
						this.billstart_month = 0;
					}
					this.billtimestamp = this.billDate.getTime();
					this.billDate = billData.billday + ' ' + months[this.billDate.getMonth()] + ' ' + this.billDate.getFullYear();
					await this.storeTracks(billData.tracks);
					await this.updateSeason();
					await this.changedDate(true);
				} else {
					this.billDay = 'endmonth';
					await this.updateSeason();
					this.changedDate(true);
				}
			} catch(e) {
				this.billDay = 'endmonth';
				await this.updateSeason();
				this.changedDate(true);
			}
		},
		async loadPayments() {
			const getinfo = await api({endpoint: this.config.services.payments, path: '/', method: 'GET'});
			let rethis = this;
		  	if (!getinfo.cards || !getinfo.cards.cards || getinfo.cards.cards.length == 0) {
		  	  //this.errorCard = {error: true, msg: `You have no card or some error occured retrieving card information.`};
		  	} else {
		  	  this.hasCard = true;
		  	  this.cards = getinfo.cards.cards;
		  		  //this.default_card = getinfo.cards.default_card;
		  		  //this.errorCard = {error: false, msg: `Your card is <u>active</u>,<br>Brand: ${getinfo.cards[0].brand}<br>Number: **** **** **** ${getinfo.cards[0].last4}<br>Exp. Date: ${getinfo.cards[0].exp_month}/${getinfo.cards[0].exp_year}`};
		  	}
			if (getinfo.tests_startDate) {
				tests_startDate = parseInt(getinfo.tests_startDate);
				this.tests_startDate = parseInt(getinfo.tests_startDate);
			}
		  	this.thismonth = getinfo.thismonth;
		  	if (getinfo.thismonth.length > 0) {
		  	 //this.tracks = getinfo.thismonth;
		  	}

		  	this.history = getinfo.history ? getinfo.history : [];
		  	if (this.history.items && this.history.items.length > 0) {
				await this.storeTracks(getinfo.history.items);
		  	}
		},
		async refreshBilling() {
			// y versus hours
			let redelay = 24 * 3600000; // hours
			let rethis = this;
			if (tests_startDate)
				redelay = 5000; // trigger fast foward

		  	now = Datex(tests_startDate);
		  	await setTimeout(async function () {
				//await rethis.loadBilling();
				//await rethis.loadPayments();
				rethis.refreshBilling();
				//rethis.changedDate();
		  	}, redelay);
	  	},
		async showPaypal() {
			console.log("Loading Paypal JS");
		},
		async showStripe() {
			  // Custom styling can be passed to options when creating an Element.
			  // (Note that this demo uses a wider set of styles than the guide below.)
			  var style = {
					base: {
				  color: '#424F65',
				  lineHeight: '18px',
				  fontFamily: '"Muli", sans-serif',
				  fontSmoothing: 'antialiased',
				  fontSize: '16px',
				  '::placeholder': {
				  color: '#D1D1D1',
				  },
					':-webkit-autofill': {
					color: '#FFCCA5',
					},
				},
				invalid: {
				  color: '#bf4336',
				  iconColor: '#bf4336'
				}
			  };

			  let that = this;

				// Floating labels
				 var inputs = document.querySelectorAll('#payment-form .InputElement');
				 Array.prototype.forEach.call(inputs, function(input) {
					 input.addEventListener('focus', function() {
						 input.classList.add('focused');
					 });
					 input.addEventListener('blur', function() {
						 input.classList.remove('focused');
					 });
					 input.addEventListener('keyup', function() {
						 if (input.value.length === 0) {
							 input.classList.add('empty');
						 } else {
							 input.classList.remove('empty');
						 }
					 });
				 });

				 var elementClasses = {
					focus: 'focused',
					empty: 'empty',
					invalid: 'invalid',
				 };
				// Create an instance of the card Element.

			  if (!cardNumber) {
					cardNumber = elements.create('cardNumber', {
					  style: style,
					  classes: elementClasses,
					  placeholder: ''
					});
				}
				cardNumber.mount('#card-element-card-number');

 			  	if (!cardExpiry) {
					cardExpiry = elements.create('cardExpiry', {
					  style: style,
					  classes: elementClasses,
					  placeholder: 'MM/YY'
					});
				}
				cardExpiry.mount('#card-element-card-expiry');
				if (!cardCvc) {
					cardCvc = elements.create('cardCvc', {
					  style: style,
					  classes: elementClasses,
					  placeholder: ''
					});
				}
				cardCvc.mount('#card-element-card-cvc');

				// registerElements([cardNumber, cardExpiry, cardCvc], 'card-element');

			  // Add an instance of the card Element into the `card-element` <div>.
			  // card.mount('#card-element');





			  // Handle real-time validation errors from the card Element.
			  cardNumber.addEventListener('change', function(event) {
				 var displayError = document.getElementById('card-errors');
				 if (event.brand) {
 			    	that.setBrandIcon(event.brand);
 			    }
				 if (event.error) {
					that.errorCard = {error: true, msg: event.error.message };
				 } else {
					that.errorCard = {error: false, msg: '' };
				 }
			  });

		},
		async setBrandIcon(brand) {
			var cardBrandToPfClass = {
			 'visa': 'pf-visa',
			  'mastercard': 'pf-mastercard',
			  'amex': 'pf-american-express',
			  'discover': 'pf-discover',
			  'diners': 'pf-diners',
			  'jcb': 'pf-jcb',
			  'unknown': 'pf-credit-card',
		  };
		   var brandIconElement = document.getElementById('brand-icon');
		   var pfClass = 'pf-credit-card';
		   if (brand in cardBrandToPfClass) {
		 	 pfClass = cardBrandToPfClass[brand];
		   }
		   for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
		 	 brandIconElement.classList.remove(brandIconElement.classList[i]);
		   }
		   brandIconElement.classList.add('pf');
		   brandIconElement.classList.add(pfClass);
	   },
		async defaultCard(tokencard) {
			const defaultcard = await api({endpoint: this.config.services.payments, path: '/setdefaultcard/'+tokencard, method: 'GET'});
			if (defaultcard && defaultcard.return === true) {
				this.hasCard = true;
				this.default_card = tokencard;
				this.errorCard = {error: false, msg: "Your default card was updated." };
			} else {
				this.errorCard = {error: false, msg: "Something went wrong making this card your default." };
			}
		},
		async sendCard() {
			let that = this;
			this.loadingCard = true;
			this.hasCard = false;
			this.errorCard = { error: false, msg: "" };
			stripe.createToken(cardNumber).then( async function(result) {
			 if (result.error) {
				// Inform the user if there was an error.
				that.errorCard = { error: true, msg: result.error.message };
				that.loadingCard = false;
			 } else {
				// Send the token to your server.
				if (result.token && result.token.card) {
					const tokencard = result.token.id;
					const newcard = await api({endpoint: that.config.services.payments, path: '/set-card/'+tokencard, method: 'GET'});
					if (newcard && newcard.return === true) {
						that.cards[0] = result.token.card;
						that.cards[0].cvc_check = 'pass';
						that.hasCard = true;
						that.errorCard = {error: false, msg: "Your card is now active, your bills will be automatically charged every recurring month."};
						that.loadingCard = false;
						that.paymentMethodDialog = false;
					} else {
						that.loadingCard = false;
						that.paymentMethodDialog = false;
						that.errorCard = {error: true, msg: "Something went wrong adding your card, please try again, another one, or contact BestAgent team."};
					}
				} else {
					that.loadingCard = false;
					that.paymentMethodDialog = false;
					that.errorCard = {error: true, msg: "Please contact BestAgent team or try again later." };
				}
			 }
			});
		},
		async deleteCard() {
			const that = this;
      that.loadingCard = true;
			await api({endpoint: that.config.services.payments, path: '/del-card/'+this.cards[0].id, method: 'GET'});
			this.cards = [];
      that.loadingCard = false;
			that.hasCard = false;
		},
		async trashCard() {
			if (this.hasCard === true && confirm("Are you sure you want to delete your card?")) {
				await this.deleteCard();
			}
		},
		async updateCard() {
			if (this.hasCard === true && confirm("Are you sure you want to update your card? the previous one will become forgotten.")) {
				await this.sendCard();
			} else if (this.hasCard === false) {
				await this.sendCard();
			}
		},
		async populateUsages() {
			let rethis=this;
			let itemvalue, itemvat;
			this.balance = 0;
			this.products = [];
			this.products_vat = 0;
			this.products_total = 0;
			let recurrBilled = {};
			if (this.iamAdmin()) {
				await this.checkAdminCard();
			}
			let trackId2Balance = {};
			let a = 0;
			await Object.keys(this.tracks).map(itemId => {
				if (a === 0){
					rethis.balance = 0;
					rethis.products = [];
					rethis.products_vat = 0;
					rethis.products_total = 0;
				}
				a++;
				let item = rethis.tracks[itemId];
				 let interval = 0;
				 if (item.item.type === 'Recurring') {
					 if (item.item.frequency == "Minute") interval = 60000;
					 else if (item.item.frequency == 'Hourly') interval = 3600000;
					 else if (item.item.frequency == 'Daily') interval = 86400000;
					 else if (item.item.frequency == 'Weekly') interval = (86400000 * 7);
					 else if (item.item.frequency == 'Monthly') interval = 2592000000;
					 else if (item.item.frequency == 'Quarterly') interval = 2592000000 * 3;
					 else if (item.item.frequency == 'Yearly') interval = 2592000000 * 12;
				 }
				 if (!trackId2Balance[item.trackId]) {
					 trackId2Balance[item.trackId] = true;
						 itemvalue = item.total ? item.total : (item.item.price * item.quantity);
				/*
				if (item.item.type === 'Recurring') {
					console.log('--------------------');
					console.log(item.item.itemId);
					console.log(parseInt(item.created_at).toString() + " = "+ (new Date(item.created_at).toString()));
					console.log(rethis.monthview);
					console.log(parseInt(rethis.monthLast.getTime()).toString() + " = " + rethis.monthLast.toString());
					console.log(parseInt(rethis.monthNow.getTime()).toString() + " = " + rethis.monthNow.toString());
					console.log(parseInt(rethis.monthFuture.getTime()).toString() + " = "+ rethis.monthFuture.toString());
					console.log('--------------------');
				}
				*/
					if (item.item.type === 'Recurring') {
							if (item.status != 'cancelled' && item.status != 'expired') {
								itemvalue = item.total ? item.total : (item.item.price * item.quantity);
								itemvat = itemvalue * rethis.vat;
								rethis.products_vat += itemvat;
								rethis.products_total += itemvalue + itemvat;
								if (!item.stripeInvoiceID || item.stripeInvoiceID === "")
									rethis.balance += itemvalue + itemvat;
							}
							/*
							if (recurrBilled[item.trackId]) {
								itemvat = recurrBilled[item.trackId] * rethis.vat;
								rethis.products_vat -= itemvat;
								rethis.products_total -= recurrBilled[item.trackId];
							} else {
								recurrBilled[item.trackId] = itemvalue;
							}
							*/
							rethis.products.push(item);

					} else if (item.status === 'issued') {
						rethis.products.push(item);
						itemvalue = item.item.price * item.quantity;
						if (item.prorata_at)
							itemvalue = parseFloat(item.total);
						itemvat = itemvalue * rethis.vat;
						rethis.products_vat += itemvat;
						rethis.products_total += itemvalue + itemvat;
						rethis.balance += itemvalue + itemvat;
					} else if (item.status === 'paid') {
						rethis.products.push(item);
						itemvalue = item.item.price * item.quantity;
						if (item.prorata_at)
							itemvalue = parseFloat(item.total);
						itemvat = itemvalue * rethis.vat;
						rethis.products_vat += itemvat;
						rethis.products_total += itemvalue + itemvat;
					} else if (item.status === 'cancelled' && item.status != 'expired') {
						rethis.products.push(item);
					}
				}
			});

			//this.products_vat = parseFloat(this.products_vat.toFixed(8));
			//this.products_total = parseFloat(this.products_total.toFixed(8));
			// Update balance for selected month

		},
		async populateSubscriptions() {
			let rethis=this;
			const servdata = await api({endpoint: this.config.services.billing, path: '/billingitems', method: 'GET'});
			rethis.subscriptions = [];
			rethis.subscriptions_tracks = [];
			if (!isNaN(servdata.balance)) {
				Object.keys(servdata.services).map(async itemId => {
					const istrack = await Object.keys(rethis.tracks).filter(post => {
			        return (rethis.tracks[post].item.itemId === itemId && servdata.services[itemId].type === 'Recurring' && (rethis.tracks[post].status != 'cancelled' && rethis.tracks[post].status != 'expired' && rethis.tracks[post].status != 'issued'))
			      });
					if (istrack.length > 0) {
						rethis.subscriptions.push(servdata.services[itemId]);
						rethis.subscriptions_tracks.push(rethis.tracks[istrack[0]]);
					}
				});
			}
		},
		updateSeason() {
			//console.log("Monthview " + this.monthview + " -> " + now.getMonth());
			this.monthNow = new Date(Datex(tests_startDate).setMonth(now.getMonth()+1));
			this.monthLast = new Date(Datex(tests_startDate).setMonth(now.getMonth()));

			this.monthNow.addMonths(this.monthview-1);
			this.monthLast.addMonths(this.monthview-1);

			this.monthNow.setHours(23);
			this.monthNow.setMinutes(59);
			this.monthLast.setHours(0);
			this.monthLast.setMinutes(1);


			if (this.billDay !== 'endmonth') {
				this.monthNow.setDate(this.billDay);
				this.monthLast.setDate(this.billDay);
			} else {
				const billDayNow = new Date(this.monthNow.getFullYear(), this.monthNow.getMonth()+1, 0).getDate();
				const billDayLast = new Date(this.monthLast.getFullYear(), this.monthLast.getMonth()+1, 0).getDate();
				this.monthNow.setDate(billDayNow);
				this.monthLast.setDate(billDayLast);
			}
		},
		async changedDate(updateHistory) {
			//this.billDate = this.billDay+" "+months[this.monthNow.getMonth()]+" "+this.monthNow.getFullYear();
			let rethis = this;
			let billDayPrev;
			let billDayNext;
			let date_one = this.monthLast;
			let date_two = this.monthNow;
			let monthyear;

			this.invoices = [];
			this.tracks = {};
			//console.log(rethis.billstart_month + " vs " + this.monthview);
			if (this.monthview === rethis.billstart_month) {
				//this.tracks = this.thismonth;
				//console.log("Loading with "+Object.keys(this.thismonth).length+" items");
				await this.storeTracks(this.thismonth);
				//console.log("Loaded "+Object.keys(this.thismonth).length+" items");
			}


			const monthyearTo = parseInt(ownDate(new Date(date_two.getFullYear(),date_two.getMonth(),date_two.getDate()-1).getTime()).toString().substr(0,8));
			const monthyearFrom = parseInt(ownDate(new Date(date_one.getFullYear(),date_one.getMonth(),date_one.getDate()).getTime()).toString().substr(0,8));

			try {
				if (updateHistory) {
						const history = await api({endpoint: this.config.services.payments, path: '/get-history', method: 'POST', body: { monthyearFrom, monthyearTo } });
						this.history = history;
						if (this.history.length > 0) {
								await Promise.all(rethis.history.map(async hist => {
									const checkexists2 = await rethis.invoices.some(obj => obj.url === hist.xeroInvoiceURL);
									let checktracking;
									let allTrackids = [];
									await Promise.all(hist.items.map(async histitm => {
										allTrackids.push(histitm.trackId);
										if (rethis.tracks[histitm.trackId]) {
											checktracking = rethis.tracks[histitm.trackId];
										}
									}));
									let tstatus = hist.items[0].item_updated.status;
									/*
									if (checktracking && checktracking.status) {
										tstatus = checktracking.status;
									}
									console.log('tstatus',tstatus);
									*/
									const updStatus = this.thismonth.filter(it => {
										return it.trackId === hist.items[0].trackId;
									});

									if (!tstatus) {
										tstatus = 'issued';
									}
									if (updStatus && updStatus[0]) {
										tstatus = updStatus[0].status;
									}
									if (!checkexists2)
										rethis.invoices.push(
											{
												name: `${hist.items.length} Item${hist.items.length === 1 ? '' : 's'}`,
												invoicedate: hist.created_at ? hist.created_at : 0,
												realdate: (hist.items[0].created_at ? hist.items[0].created_at : hist.items[0].item_updated.created_at),
												date: `${rethis.dateToYMD(new Date(hist.items[0].created_at ? hist.items[0].created_at : hist.items[0].item_updated.created_at))}`,
												url: hist.xeroInvoiceURL,
												trackId: allTrackids,
												status: tstatus,
												total: hist.total.toFixed(2)
											}
										);
									if (hist.items && hist.items.length > 0) {
										await this.storeTracks(hist.items);
									}
								}));
						} else { // Show default subscriptions
								await this.storeTracks(this.subscriptions_tracks);
						}
				}

				if (this.billDay == 'endmonth') {
					billDayPrev = new Date(date_one.getFullYear(), date_one.getMonth()+1, 0).getDate();
					billDayNext = new Date(date_two.getFullYear(), date_two.getMonth()+1, 0).getDate();
				} else {
					billDayPrev = this.billDay;
					billDayNext = this.billDay;
				}

				if (parseInt(now.getFullYear()) === parseInt(date_one.getFullYear())) {
					this.billprev = billDayPrev + '/' + months[date_one.getMonth()];
				} else {
					this.billprev = billDayPrev + '/' + months[date_one.getMonth()] + '/' + date_one.getFullYear();
				}

				if (parseInt(now.getFullYear()) === parseInt(date_two.getFullYear())) {
					this.billnext = billDayNext + '/' + months[date_two.getMonth()];
				} else {
					this.billnext = billDayNext + '/' + months[date_two.getMonth()] + '/' + date_two.getFullYear();
				}
				await this.populateUsages();
			} catch(e) {
				console.log(e.msg);
				await this.populateUsages();
			}
		},
		iamAdmin() {
			const isadm = this.$store.getters.adminCompanyId ? true : false;
			return isadm;
		},
		async checkAdminCard() {
				const hascards = await api({endpoint: this.config.services.payments, path: '/getcardCompany/'+this.$store.getters.adminCompanyId, method: 'GET' });
				this.adminCards = hascards;
		},
		nextMonth() {
			if (this.monthview < 1)
				this.monthview++;
		},
		prevMonth() {
			if (this.firstbill_at !== 0 && this.monthLast.getTime() > this.firstbill_at)
				this.monthview--;
		},
		frequencyStr(frequency) {
			switch(frequency) {
				case 'minute': frequency = 'minute'; break;
				case 'hourly': frequency = 'hour'; break;
				case 'daily': frequency = 'day'; break;
				case 'weekly': frequency = 'week'; break;
				case 'monthly': frequency = 'month'; break;
				case 'quaterly': frequency = 'quarter'; break;
				case 'yearly': frequency = 'year'; break;
			}
			return frequency;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/BillingPanel.vue